import type { FiltersValue } from '~features/dashboard-filters';

import type { PaymentStatus } from '~entities/payment';
import type {
  FindPaymentsRequestFilter,
  FindPaymentsRequestSort,
} from '~entities/payment/model/find-payments-params';

import type { SortingState } from '~shared/ui/dashboard-table';

import { endOfDay, startOfDay } from 'date-fns';

import { ColumnId } from './columns';

const orderMapping = {
  asc: 'ASC',
  desc: 'DESC',
} as const;

type ColumnsWithSort = ColumnId.STATUS | ColumnId.SETTLED_AMOUNT;

const columnToOrderByMapping: Record<
  ColumnsWithSort,
  FindPaymentsRequestSort['key']
> = {
  [ColumnId.STATUS]: 'paymentTimestampUTC',
  [ColumnId.SETTLED_AMOUNT]: 'settledAmount',
} as const;

export function sortToParams({
  orderBy,
  direction,
}: SortingState): FindPaymentsRequestSort {
  return {
    key: columnToOrderByMapping[orderBy as ColumnsWithSort],
    order: orderMapping[direction],
  };
}

export function filtersToParams({
  period,
  posIds,
  merchantIds,
  statuses,
}: FiltersValue<PaymentStatus>): FindPaymentsRequestFilter {
  const { startDate, endDate } = period ?? {};
  const dateTo = endDate ? new Date(endDate) : new Date();
  const dateFrom = startDate ? new Date(startDate) : new Date();

  return {
    dateTo: endOfDay(dateTo).toISOString(),
    dateFrom: startOfDay(dateFrom).toISOString(),
    merchantIds,
    pointOfSaleIds: posIds,
    paymentStatuses: statuses,
  };
}
